<template>
    <div class="challengeallocation">
        <div class="container-fluid">
            <div class="row vertical-align margin-bottom-2Perc">
            </div>
        </div>    
        <challenge-allocation-filter-bar @selectedValues="updateSelectedValues"></challenge-allocation-filter-bar>
        <peer-allocation-list v-for="(Obj, index) in getSelectedRegularChallengeMaxPeerAllocationCount" :key="index" :currIndex="index" :selectedFilterValuesObj="selectedFilterValuesObj" :peerList="getSubmittedUserResponseList" v-if="getSubmittedUserResponseList.length > 0"></peer-allocation-list>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
        </div> 
        <loader></loader>     
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { challengeService } from '@/server-util/challenge-service'
import AlertBox from '@/components/AlertOverlay'
import ChallengeAllocationFilterBar from '@/components/users/challenge_allocation/ChallengeAllocationFilterBar'
import PeerAllocationList from '@/components/users/challenge_allocation/PeerAllocationList'
export default {
  created: function () {},
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedFilterValuesObj: null,
      submittedUserResponseList: []
    }
  },
  methods: {
    updateSelectedValues (value) {
      this.selectedFilterValuesObj = value
      // console.log(JSON.stringify(this.selectedFilterValuesObj))
      this.getSubmittedUserResponses()
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getSubmittedUserResponses: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedFilterValuesObj !== undefined &&
        this.selectedFilterValuesObj !== '' &&
        this.selectedFilterValuesObj !== undefined
      ) {
        _this.submittedUserResponseList = []
        _this.$store.state.isLoading = true
        challengeService
          .getSubmittedChallengeResponseUsers(storeObj.state.access_token, this.selectedFilterValuesObj.selectedCohortObj.CohortId, this.selectedFilterValuesObj.selectedStepObj.ElemChallenge.ElementChallengeId)
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.submittedUserResponseList = responseObj.data
                _this.$store.state.isLoading = false
                if (_this.submittedUserResponseList.length === 0) {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'None of user(s) have submitted response for the \'' + this.selectedFilterValuesObj.selectedStepObj.Title + '\' challenge.'
                }
              } else {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              // AK: Hide Spinner
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'Selected ModuleId is NULL hence declined CREATE CHALLENGE ELEMENT OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'challenge-allocation-filter-bar': ChallengeAllocationFilterBar,
    'peer-allocation-list': PeerAllocationList
  },
  computed: {
    getSubmittedUserResponseList: {
      get: function () {
        return this.submittedUserResponseList
      }
    },
    getSelectedFilterValuesObj: {
      get: function () {
        return this.selectedFilterValuesObj
      }
    },
    getSelectedRegularChallengeObj: {
      get: function () {
        if (this.getSelectedFilterValuesObj !== undefined && this.getSelectedFilterValuesObj !== null && this.getSelectedFilterValuesObj !== '' && this.getSelectedFilterValuesObj !== 'null') {
          return this.getSelectedFilterValuesObj.selectedStepObj
        } else {
          return null
        }
      }
    },
    getSelectedRegularChallengeMaxPeerAllocationCount: {
      get: function () {
        if (this.getSelectedRegularChallengeObj !== undefined && this.getSelectedRegularChallengeObj !== null && this.getSelectedRegularChallengeObj !== '' && this.getSelectedRegularChallengeObj !== 'null') {
          return this.getSelectedRegularChallengeObj.ElemChallenge.MaxPeerAllocations
        } else {
          return 0
        }
      }
    }
  },
  watch: {},
  name: 'challengeallocation'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-2Point5Perc {
  margin-top: 2.5%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5% !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.enroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width {
  width: 95%;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.img-align-middle{
    margin-left: auto;
    margin-right: 0px;
}
.text-decoration-none {
  text-decoration: none !important;
}
.padding-left-2Point7Perc{
  padding-left:2.7%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-right{
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.margin-top-1Point7Perc {
  margin-top: 1.7%
}
.center-align {
    margin: auto;
    width: 20%;
    /* border: 3px solid green; */
    /* padding: 10px; */
}
</style>


// WEBPACK FOOTER //
// src/components/users/challenge_allocation/ChallengeAllocation.vue